<a
  (click)="redirectArticle()"
  (keydown.enter)="redirectArticle()"
  (keydown.space)="redirectArticle()"
  class="button"
  tabindex="0"
  role="button"
  class="button"
>
  <div class="box text-center div-tour">
    <h3 *ngIf="tour.name">{{ tour.name }}</h3>
  </div>
</a>
